/**
 * @module components\SettlementDetails
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { maxLength, minLength, required, requiredIf, alphaNum } from "vuelidate/lib/validators";
import _ from 'lodash';
import * as XLSX from "xlsx";
import sToast from '@/services/sToast';
import axios from 'axios';
import core from '@/services/core';
import store from '@/store';
import moment from 'moment';

@Component({
  validations: function (this: SettlementDetails) {
    let validation: any = {
      idType: { required },
      uniqueId: {
        required: requiredIf(() => { return this.idType != "DATE_FIL" }),
        minLength: minLength(this.idType == 'BATCH_ID' ? 19 : 10),
        maxLength: maxLength(this.idType == 'BATCH_ID' ? 21 : 26),
        alphaNum
      },
      fromDate: { required: requiredIf(() => { return (this.toDate) || (this.idType == 'DATE_FIL') }) },
      toDate: { required: requiredIf(() => { return (this.fromDate) || (this.idType == 'DATE_FIL') }) },
    }
    return validation;
  }
})
export default class SettlementDetails extends Vue {
  search = "";
  pageNumber = 1;
  isFilterEnable = false;
  btnTxt = "Search"
  currentPage = this.pageNumber;
  pageNumberToHitAPI = 0;
  recordNumber = 1;
  module = ['All', 'Agent', 'Customer'];
  fromDate = "";
  toDate = "";
  mxDate = moment().format("YYYY-MM-DD");
  superInitData = null;
  finoClientId = "";
  headers = [];
  historys = [];
  itemsModules = [];
  historyResponse: any = {};
  json_fields = {};
  dataExcel = [];
  downloadFile = false;
  downloadFileLoader = true;
  tab = store.getters.tabKeyGet.tab;
  reqModule = store.getters.tabKeyGet.requestModule;
  uniqueId: any = "";
  idType: any = "DATE_FIL";
  idTypeList = [{ 'displayName': 'Date', 'value': 'DATE_FIL' }, { 'displayName': 'Batch ID', 'value': 'BATCH_ID' }, { 'displayName': 'UTR No', 'value': 'UTR_NO' }];

  defaultDisplay: boolean = true;

  selectIdType() {
    this.defaultDisplay = false;
    this.fromDate = "";
    this.toDate = "";
    this.uniqueId = "";
    if (this.idType !== "DATE_FIL") {
      this.defaultDisplay = false;
    } else {
      this.defaultDisplay = true;
      this.$refs["child1"].clear();
      this.$refs["child"].clear();
    }
    this.$v.$reset();
  }

  fetchTxnHistory(src, isBtn) {
    if (this.$v.$invalid && src == 'VIEW') {
      this.$v.$touch();
      return;
    }
    if (src == 'VIEW' && isBtn) {
      this.historys = [];
    }

    let filterB_BatchId = "";
    let filterC_UTRNo = "";
    if (this.uniqueId) {
      this.fromDate = "";
      this.toDate = "";
      this.finoClientId = "";
      if (this.idType == "BATCH_ID") {
        filterB_BatchId = this.uniqueId;
      } else {
        filterC_UTRNo = this.uniqueId;
      }
    }
    let request = { "token": store.getters.sessLoginDataGet.sessionId, "merchantClientId": this.clientDetails.clientId, "fromDate": this.fromDate != '' ? moment(this.fromDate).format("DD/MM/YYYY") : '', "toDate": this.toDate != '' ? moment(this.toDate).format("DD/MM/YYYY") : '', "requestType": src, "requestModule": this.reqModule, "recordNumber": this.recordNumber, "finoClientId": "", "aggId": "", "filter_A": "", "filter_B": filterB_BatchId, "filter_C": filterC_UTRNo, "filter_D": "", "filter_E": "", "tabKey": this.tab };
    core
      .post({
        data: request,
        url: 'fetchCmsHist',
        method: 'post'
      })
      .then(response => {
        this.isFilterEnable = true;
        this.btnTxt = "Clear Filters";
        this.historyResponse = response;
        if (response.historyData.length > 0) {
          if (isBtn) {
            this.historys = [];
          }
          this.historys.push(...response.historyData);
          this.headers = response.headers;
          this.setDrawerState();
        }
        if (response.historyData.length <= 0) {
          //this.historys=[];
        }
      })
      .catch(error => {
        this.isFilterEnable = true;
        this.btnTxt = "Clear Filters";
      });
  }

  setDrawerState() {
    store.dispatch('updateUserNavDataAc', false)
  }

  get moduleClient() {
    return this.itemsModules.filter(obj => {
      return obj.value == this.finoClientId
    })
  }
  get clientDetails() {
    return store.getters.updateSuperInitDataGet.payload2[0];
  }
  get paginationLength() {
    if (this.historys.length === 0) {
      return 0;
    }

    const temp = (
      this.historys.length / this.historyResponse.pageSize
    ).toString();
    let pagesToBeAdded = 0;
    if (this.historyResponse.isEof === false) {
      pagesToBeAdded = 1;
    }
    let pages = 0;
    if (temp.includes('.')) {
      pages = +temp.split('.')[0] + 1;
      this.pageNumberToHitAPI = pages;
    } else {
      pages = +temp + pagesToBeAdded;
      this.pageNumberToHitAPI = pages;
    }
    if (this.historyResponse.isEof === true) {
      this.pageNumberToHitAPI = 0;
    }

    return pages;
  }
  changePageNumber(pageNumber: number) {

    if (pageNumber === this.pageNumberToHitAPI) {
      this.recordNumber = this.recordNumber + 1;
      this.pageNumberToHitAPI = 0;
      this.fetchTxnHistory('VIEW', false)
    }
  }

  getStatusColor(status) {
    switch (status.toUpperCase()) {
      case 'SUCCESS':
      case 'CLOSED':
        return 'color:#34a853';
      case 'CONFIRMED':
        return 'color:#293896';

      case 'FAILED':
      case 'EXPIRED':
        return 'color:#ea4335';

      case 'PENDING':
      case 'INITIATED':
        return 'color:#E88A00';
      default:
        return '';
    }
  }

  get mobileTableData() {
    if (this.search) {
      return this.historys.filter((obj) => {
        for (const [key, value] of Object.entries(obj)) {
          // @ts-ignore
          if (value.includes(this.search)) {
            return true;
          }
        }
      })
    } else {
      return this.historys.slice(
        (this.currentPage - 1) * this.historyResponse.pageSize,
        this.currentPage * this.historyResponse.pageSize
      );
    }
  }

  get mnDate() {
    return moment("2020-01-01").format("YYYY-MM-DD")
  }
  toMxDate = moment().format("YYYY-MM-DD");
  checkDate() {
    if (this.fromDate) {
      const dateRange = this.staticData ? this.getVersionInfosValues('HistoryDateRange') : '';
      let finalDate = dateRange.length > 0 ? moment(this.fromDate).add(parseInt(dateRange[0].keyValue), 'd').format('YYYY-MM-DD') : moment().add(7, 'd').format('YYYY-MM-DD');
      if (moment(finalDate).isAfter(moment())) {
        this.toDate = "";
        // @ts-ignore
        this.$refs["child1"].clear();
        this.toMxDate = moment().format('YYYY-MM-DD');
      } else if (moment(this.toDate).diff(this.fromDate, 'days') > parseInt(dateRange[0].keyValue)) {
        this.toDate = "";
        // @ts-ignore
        this.$refs["child1"].clear();
        this.toMxDate = finalDate;
      } else if (moment(this.fromDate).isAfter(this.toDate)) {
        this.toDate = "";
        // @ts-ignore
        this.$refs["child1"].clear();
        this.toMxDate = finalDate;
      }
      else {
        this.toMxDate = finalDate;
      }
    } else {
      this.toMxDate = moment().format('YYYY-MM-DD');
    }
  }

  get staticData() {
    return store.getters.staticDataGet;
  }


  getVersionInfosValues(key) {
    if (this.staticData.payload['versionInfos']) {
      return this.staticData.payload['versionInfos'].filter(obj => {
        return obj.keyName === key;
      })
    } else {
      return [{ keyValue: "7" }]
    }

  }

  get dateRangeDays() {
    return this.superInitData ? `History can be viewed within a date range of ${this.getVersionInfosValues('HistoryDateRange')[0].keyValue} days.` : '';
  }
  clearBtnFilter() {
    this.isFilterEnable = false;
    this.btnTxt = "Search"
  }

  mounted() {
    this.superInitData = store.getters.updateSuperInitDataGet;
    this.itemsModules = _.orderBy(this.superInitData['cmsSearchModule'], 'dispalyName');
  }
  $refs = {};
  clearFilter() {
    this.finoClientId = '';
    this.historys = [];
    this.counter = 1;
    this.recordNumber = 1;
    this.pageNumber = 1;
    this.currentPage = 1;
    this.headers = [];
    this.search = "";
    this.btnTxt = "Search";
    this.isFilterEnable = false;
    this.selectIdType();
  }



  counter = 1;
  headerExcel: any = [];
  async fetchData() {
    try {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.downloadFile = true;
      let filterB_BatchId = "";
      let filterC_UTRNo = "";
      if (this.uniqueId) {
        this.fromDate = "";
        this.toDate = "";
        this.finoClientId = "";
        if (this.idType == "BATCH_ID") {
          filterB_BatchId = this.uniqueId;
        } else {
          filterC_UTRNo = this.uniqueId;
        }
      }
      let request = { "tabKey": this.tab, "token": store.getters.sessLoginDataGet.sessionId, "merchantClientId": this.clientDetails.clientId, "fromDate": this.fromDate != '' ? moment(this.fromDate).format("DD/MM/YYYY") : '', "toDate": this.toDate != '' ? moment(this.toDate).format("DD/MM/YYYY") : '', "requestType": 'DOWNLOAD', "requestModule": this.reqModule, "recordNumber": this.counter, "filter_A": "", "filter_B": filterB_BatchId, "filter_C": filterC_UTRNo, "filter_D": "", "filter_E": "" };
      const response = await axios({
        data: request,
        url: window.location.origin + '/MFINWeb/fetchCmsHist',
        method: 'post'
      });
      if (response.data.responseCode == '099' || !response.data) {
        this.downloadFile = false;
        sToast.show({
          message: response.data.msgDesc,
          intent: "error",
          timeout: 6000
        });
        return;
      }
      response['data'].headers.forEach(element => {
        if (element.text != response['data']['clickableColumnName']) {
          this.json_fields[element.text] = element.value;
        }
      });
      if (response['data'].headers) {
        this.headerExcel = response['data'].headers;
      }
      this.dataExcel.push(...response['data']['historyData']);
      if (!response.data.isEof) {
        this.counter = this.counter + 1;
        this.fetchData();
      }
      else {
        this.downloadFileLoader = false;
      }
    } catch (e) {
      this.downloadFile = false;
    }

  }
  fileName() {
    return moment().unix();
  }
  onexport() { // On Click Excel download button

    // export json to Worksheet of Excel
    // only array possible
    let excelData = [];
    excelData = _.cloneDeep(this.dataExcel);
    excelData.forEach((obj) => {
      for (const [key, value] of Object.entries(obj)) {
        this.headerExcel.forEach((head) => {
          if (head.value == key) {
            obj[head.text] = value;
            if (head.text == this.historyResponse.clickableColumnName) {
              delete obj[head.text];
            }
            delete obj[key];
          } else {
            delete obj[key];
          }
        })
      }
    })
    var SheetWS = XLSX.utils.json_to_sheet(excelData);
    // A workbook is the name given to an Excel file
    var wb = XLSX.utils.book_new() // make Workbook of Excel
    // add Worksheet to Workbook
    // Workbook contains one or more worksheets
    XLSX.utils.book_append_sheet(wb, SheetWS, 'Sheet1') // sheetAName is name of Worksheet
    // export Excel file
    XLSX.writeFile(wb, `${this.fileName()}.xlsx`) // name of the file is 'book.xlsx'*/
  }
}
